import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';


export const SolidCircleChart = ({ activity }: { activity: ApexOptions }) => {
  return (
    <ReactApexChart
      options={activity}
      series={activity.series}
      type="radialBar"
      height={310}
    />
  );
};
